module.exports = __webpack_public_path__ + "media/components/country-flag/static/gb-nir-79bda6e0faddb0f15accb9a1edc56b39.svg";